"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgEmojiSmallHappy = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none" }, props),
    React.createElement("circle", { cx: 8, cy: 8, r: 7, fill: "#9DD3B4" }),
    React.createElement("path", { fill: "#377B56", fillRule: "evenodd", d: "M4.278 9.326a.465.465 0 0 1 .623.21 3.457 3.457 0 0 0 6.196 0 .465.465 0 1 1 .833.413 4.387 4.387 0 0 1-7.862 0 .465.465 0 0 1 .21-.623M5.135 4.75a2.6 2.6 0 0 1 1.65-.206.465.465 0 1 1-.185.91 1.68 1.68 0 0 0-1.827.88.465.465 0 0 1-.828-.423c.26-.507.678-.915 1.19-1.162M10.462 5.587A1.68 1.68 0 0 0 9.4 5.454a.465.465 0 1 1-.185-.91 2.61 2.61 0 0 1 2.84 1.367.465.465 0 0 1-.828.423 1.68 1.68 0 0 0-.765-.747", clipRule: "evenodd" })));
exports.default = SvgEmojiSmallHappy;
